import React from 'react'
import { Outlet } from 'react-router-dom'

export const WorkshopgroupBase: React.FC = () => {
  return <Outlet />
}
